import {Component, Input, OnInit} from '@angular/core';
import {CabecalhoService} from '../../services/cabecalho.service';
import {AuthService} from '../../services/auth.service';
import {UsuarioBc} from '../../model/usuario-bc';
import {Router} from '@angular/router';
import {StorageService} from '../../services/storage.service';
import {REDIRECT_URL, URL_NOVO_PORTAL} from '../../util/constants';

@Component({
  selector: 'app-cabecalho',
  templateUrl: './cabecalho.component.html',
  styleUrls: ['./cabecalho.component.scss']
})
export class CabecalhoComponent implements OnInit {

  isLogado: boolean;
  isOuro: any = false;
  showModalAvisoAlerta: any = false;
  tituloAviso = 'Atenção!';
  textoAviso = "Para acessar esta funcionalidade, é necessário possuir o selo ouro no Gov.br. Verifique sua autenticação para continuar.<br><br> <a href='https://www.gov.br/governodigital/pt-br/identidade/conta-gov-br/niveis-da-conta-govbr/saiba-mais-sobre-os-niveis-da-conta-govbr' target='_blank'>Saiba mais sobre os níveis da conta</a>";
  config: any;
  usuarioLogado: UsuarioBc;
  @Input() corPrimaria: string;
  @Input() showBackButton: boolean;
  @Input() sipni: boolean;
  @Input() app: any;

  constructor(
    private router: Router,
    private cabecalhoService: CabecalhoService,
    private authService: AuthService,
    private storage: StorageService
  ) { }

  async ngOnInit() {
    this.config = await this.cabecalhoService.get();
    this.config.links.forEach((link: any) => {
      if (link.arquivo) {
        const arraySplit = link.arquivo.url.split('http://');
        if (arraySplit.length > 1) {
          link.arquivo.url = 'https://' + arraySplit[1];
        }
      }
    });
    await this.verificarUsuarioLogado();
  }

  async verificarUsuarioLogado() {
    this.isLogado = await this.authService.existeUsuarioLogado();
    this.usuarioLogado = await this.authService.getUsuarioLogado();
    if (this.isLogado) {
      this.isOuro = await this.authService.buscarConfiabilidade();
    }
  }

  async sair(confirmacao: boolean) {
    if (confirmacao) {
      this.authService.logout();
      this.verificarUsuarioLogado();
      await this.router.navigateByUrl('/');
    }
  }

  logar() {
    console.log('====APP====', this.app);
    if (this.app) {
      localStorage.setItem('URL_SOLICITACAO_ACESSO', '/solicitacao-de-acesso');
      localStorage.setItem('LOGIN_BY_SOLICITACAO_ACESSO', 'SIM');
      this.storage.setCurrentApp(JSON.stringify(this.app));
      const redirectUrl = `${REDIRECT_URL}`;
      this.authService.loginBrasilCidadao(redirectUrl);
    } else {
      localStorage.setItem('LOGIN_BY_SOLICITACAO_ACESSO', 'NAO');
      const redirectUrl = `${REDIRECT_URL}`;
      this.authService.loginBrasilCidadao(redirectUrl);
    }
  }

  async redirect(url) {
    if (this.isOuro) {
      await this.router.navigateByUrl(url);
    } else {
      this.showModalAvisoAlerta = true;
    }
  }
  async fecharModalAvisoAlerta() {
    this.showModalAvisoAlerta = false;
  }

  protected retornarNovoPortal() {
    const url = URL_NOVO_PORTAL;
    if (this.storage.getObjLogin()) {
      const token = this.storage.getObjLogin();
      if (token) {
        this.storage.clearAll();
        const param = new URLSearchParams(token);
        window.open(`${url}/login?${param.toString()}`, '_self');
      }
    } else {
      window.open(`${url}`, `_self`);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/cabecalho/cabecalho.component.ts